import { useEffect, useState } from "react";

const supportsMatchMedia = () => typeof window !== "undefined" && typeof window.matchMedia === "function";

// Read on the first render, so the first paint is already right; false where matchMedia is missing (jsdom).
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => supportsMatchMedia() && window.matchMedia(query).matches);
  useEffect(() => {
    if (!supportsMatchMedia()) return undefined;
    const list = window.matchMedia(query);
    const update = () => setMatches(list.matches);
    update();
    // addListener, not addEventListener: Safari before 14 has only this.
    list.addListener(update);
    return () => list.removeListener(update);
  }, [query]);
  return matches;
};
